export default __webpack_public_path__ + "ecc6af6478d48df022ebc18f07adff46.jpg";